import railyApiService from "../raily-api.service";
import PartnerDetailsRequest from "./details/partner-details.request";
import PartnerDetailsResponse from "./details/partner-details.response";

const partnerApiService = () => {
  const getDetails = async (
    request: PartnerDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<PartnerDetailsResponse> => {
    const url = `/partners/${request.fleetPartnerId}`;

    return railyApiService().get<PartnerDetailsResponse>({
      url,
      abortSignal,
    });
  };

  return {
    getDetails,
  };
};

export default partnerApiService;
